import React from 'react';
function OptionsItemInput(props) { return /*#__PURE__*/ React.createElement("input", Object.assign({ className: "options__item__input", type: "checkbox" }, props)); }
export default OptionsItemInput;
